module.exports = __webpack_public_path__ + "8ac8063dd7961d2c1064a00c32396200.png";